import { render, staticRenderFns } from "./tabMenu.vue?vue&type=template&id=74a2124c&scoped=true"
import script from "./tabMenu.vue?vue&type=script&lang=js"
export * from "./tabMenu.vue?vue&type=script&lang=js"
import style0 from "./tabMenu.vue?vue&type=style&index=0&id=74a2124c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2124c",
  null
  
)

export default component.exports